import { QueryCache, QueryClient } from 'react-query';

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: false,
			refetchOnWindowFocus: false,
			staleTime: 30_000,
			cacheTime: 30_000,
		},
	},
	queryCache: new QueryCache({
		onError: (error, query) => {
			if (query.queryKey[0] !== 'organisation/all')
				window.location.href = '/error/404';
		},
	}),
});
